module.exports = __webpack_public_path__ + "static/media/WETH.f4891222.png";